const APIService = require('../APIService');
const formatError = require('../../../utils/formatError');

class CPTBillingCodes extends APIService {
  constructor({ examTypeId }) {
    super();
    this._url = `/clinic-definition/exam-types/${examTypeId}/billing-codes`;
  }

  async getAll({ parameters }) {
    try {
      const { data } = await this.httpClient.get(
        `${this._url}?offset=${parameters.offset || 0}&limit=${parameters.limit}`,
      );
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async get() {
    try {
      const { data } = await this.httpClient.get(`${this._url}/${id}`);
      return data.results;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async patch({ id, payload }) {
    try {
      const { data } = await this.httpClient.patch(`${this._url}/${id}`, payload);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async delete({ id }) {
    try {
      const { data } = await this.httpClient.delete(`${this._url}/${id}`);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async create({ payload }) {
    try {
      const { data } = await this.httpClient.post(`${this._url}`, payload);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async enableAll() {
    try {
      const { data } = await this.httpClient.post(`${this._url}/enable-all`);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async disableAll() {
    try {
      const { data } = await this.httpClient.post(`${this._url}/disable-all`);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async enable({ id }) {
    try {
      const { data } = await this.httpClient.post(`${this._url}/${id}/enable`);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }

  async disable({ id }) {
    try {
      const { data } = await this.httpClient.post(`${this._url}/${id}/disable`);
      return data;
    } catch (error) {
      throw new Error(formatError(error));
    }
  }
}

module.exports = CPTBillingCodes;
